var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCreditCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6667 16.6673H3.33334M3.33334 13.6673L3.33334 26.334C3.33334 28.2008 3.33334 29.1342 3.69666 29.8473C4.01623 30.4745 4.52617 30.9844 5.15337 31.304C5.86641 31.6673 6.79983 31.6673 8.66668 31.6673L31.3333 31.6673C33.2002 31.6673 34.1336 31.6673 34.8466 31.304C35.4739 30.9844 35.9838 30.4745 36.3034 29.8473C36.6667 29.1342 36.6667 28.2008 36.6667 26.334V13.6673C36.6667 11.8005 36.6667 10.8671 36.3034 10.154C35.9838 9.52681 35.4739 9.01688 34.8466 8.6973C34.1336 8.33399 33.2002 8.33399 31.3333 8.33399L8.66668 8.33398C6.79984 8.33398 5.86642 8.33398 5.15338 8.6973C4.52617 9.01687 4.01623 9.52681 3.69666 10.154C3.33334 10.8671 3.33334 11.8005 3.33334 13.6673Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCreditCard);
export default __webpack_public_path__ + "static/media/iconCreditCard.8146db498a433b89433617a8b97a3396.svg";
export { ForwardRef as ReactComponent };